import React, { useState } from 'react';

import cs from 'classnames';

const AmbientListeningSidebar = () => {
  const [activeStep] = useState(1);

  const steps = [
    { id: 1, title: 'Ambient Listening' },
    { id: 2, title: 'Transcription' },
    { id: 3, title: 'Edit & Finalize' }
  ];

  return (
    <div className="ambient-sidebar p-5">
      <div className="steps-container">
        {steps.map((step) => (
          <div key={step.id} className="step-item relative mb-4 flex items-center py-2">
            <div
              className={cs(
                'absolute left-0 h-full w-[2px] bg-neutral-200 transition-colors duration-300',
                activeStep === step.id && 'bg-primary-500'
              )}
            />
            <div className="ml-5">
              <span
                className={cs(
                  'font-normal text-neutral-800',
                  activeStep === step.id && 'font-bold text-primary-500'
                )}>
                {step.title}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AmbientListeningSidebar;
